import React, { useState, useEffect } from 'react';
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axiosInstance from '../../axiosInstance';
import "../../App.css";

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axiosInstance.post('/contact', formData);
      console.log('Form submitted successfully:', response.data);
      setSuccessMessage('Message sent successfully!');
      setFormData({ name: '', email: '', message: '' }); // Reset form
      setTimeout(() => setSuccessMessage(''), 10000); // Hide message after 10 seconds
    } catch (error) {
      console.error('Error submitting form:', error);
      setSuccessMessage('Failed to send message. Please try again.');
      setTimeout(() => setSuccessMessage(''), 10000);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => setSuccessMessage(''), 10000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  return (
    <div className='max-w-7xl mx-auto px-4 py-12'>
      <h1 className='text-4xl font-semibold mb-3 text-gray-900 dark:text-[rgb(211,219,236)]'>Contact me</h1>
      <p className='text-lg mb-6 text-gray-900 dark:text-[rgb(211,219,236)] tracking-wide'>
        You can fill this form or contact me directly at <a href="mailto:slam01raoui@gmail.com" className='underline'>slam01raoui@gmail.com</a>
      </p>
      {successMessage && (
        <div className='bg-green-700 max-w-7xl border border-green-400 text-[rgb(211,219,236)] px-4 py-3 rounded relative mb-4 w-[60%] max-sm:w-full' role="alert">
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}
      <form onSubmit={handleSubmit} className='w-[60%] max-sm:w-full'>
        <input type="text" name="name" placeholder='Name' value={formData.name} onChange={handleChange} className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2 my-6 text-gray-900 dark:text-[rgb(211,219,236)]' required />
        <input type="email" name="email" placeholder='Email' value={formData.email} onChange={handleChange} className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2 my-6 text-gray-900 dark:text-[rgb(211,219,236)]' required />
        <textarea name="message" placeholder='Message' value={formData.message} onChange={handleChange} className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2 my-6 text-gray-900 dark:text-[rgb(211,219,236)]' rows='7' required></textarea>
        <button type="submit" disabled={isLoading} className={`bg-blue-200 dark:bg-yellow-600 px-6 py-3 text-gray-900 dark:text-[rgb(211,219,236)] rounded-md hover:dark:bg-yellow-700 hover:bg-blue-400 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}>
          {isLoading ? 'Sending...' : 'Send'}
        </button>
      </form>
      <div className='flex items-center justify-between pt-24'>
        <Link to='/projects' className="mb-4 nav-link py-2 dark:text-white text-[#111318] rounded">
          <FontAwesomeIcon icon={faArrowLeft} className='text-lg pr-1' /> Projects
        </Link>
        <Link to='/' className="mb-4 nav-link py-2 dark:text-white text-[#111318] rounded">
          Page Home <FontAwesomeIcon icon={faArrowRight} className='text-lg pr-1' />
        </Link>
      </div>
    </div>
  );
};

export default Contact;